import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"delete\"><path fill=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M17.347 23H6.653c-1.181 0-2.14-.985-2.14-2.2V6.5H2.376V4.3h4.278V3.2c0-1.215.957-2.2 2.139-2.2h6.416c1.182 0 2.14.985 2.14 2.2v1.1h4.277v2.2h-2.139v14.3c0 1.215-.957 2.2-2.139 2.2ZM6.653 6.5v14.3h10.694V6.5zm2.139-3.3v1.1h6.416V3.2zm6.416 15.4H13.07V8.7h2.14v9.9Zm-4.277 0H8.79V8.7h2.14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol